import { useDashboardShareActions } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { SUPPORTED_CHANNELS } from '../../constants';
import { isSupportedChannelAction } from '../../helpers';
import type { SupportedChannelShareAction } from '../../types';

export function useShareSocial(): SupportedChannelShareAction[] {
	const actions = useDashboardShareActions();

	// For the reskin, we only want to show a subset of channels and in a specific order
	return actions
		.slice()
		.sort((a, b) => SUPPORTED_CHANNELS.indexOf(a.channel) - SUPPORTED_CHANNELS.indexOf(b.channel))
		.filter(isSupportedChannelAction);
}
